// extracted by mini-css-extract-plugin
export default {"btn-primary":"Button_btn-primary__pagUa","btn--inverse":"Button_btn--inverse__2fbEM","btn--round":"Button_btn--round__jmATc"};